import type { StatusTagItem } from '@/components';
import { AllocationStatus } from '@/types';

export const ALLOCATION_STATUS_LABELS: Record<AllocationStatus, string> = {
  [AllocationStatus.ALLOCATED]: 'Allocated',
  [AllocationStatus.EMPTY]: 'Empty',
  [AllocationStatus.LOCKED]: 'Locked',
  [AllocationStatus.PUBLISHED]: 'Published',
  [AllocationStatus.PO_CANCELLED]: 'PO Cancelled',
  [AllocationStatus.CLOSED]: 'Closed',
  [AllocationStatus.DISCARDED]: 'Discarded'
};

const ALLOCATION_STATUS_COLORS: Record<
  AllocationStatus,
  StatusTagItem['color']
> = {
  [AllocationStatus.ALLOCATED]: 'purple',
  [AllocationStatus.EMPTY]: 'neutral',
  [AllocationStatus.LOCKED]: 'green',
  [AllocationStatus.PUBLISHED]: 'blue',
  [AllocationStatus.PO_CANCELLED]: 'red-inverse',
  [AllocationStatus.CLOSED]: 'red',
  [AllocationStatus.DISCARDED]: 'red-inverse'
};

/**
 * Single-letter items for the narrow status columns. Several statuses share a
 * first letter; the colour and the full-name tooltip tell them apart.
 */
export const ABBREVIATED_ALLOCATION_STATUS_ITEMS: StatusTagItem[] =
  Object.values(AllocationStatus).map(status => ({
    value: status,
    label: ALLOCATION_STATUS_LABELS[status].slice(0, 1),
    tooltip: ALLOCATION_STATUS_LABELS[status],
    color: ALLOCATION_STATUS_COLORS[status]
  }));
